import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { postNotificationRequest, postNotificationRequestError, postNotificationRequestSuccess } from '../../slices/send-notification/PostNotificationSlice';

export const SendNotificationAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(postNotificationRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.sendNotification,
                data: data,
            })
            return dispatch(postNotificationRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(postNotificationRequestError(_error));
        }
    };
};
